import { Broadcast, MappingType } from 'videoservice-openapi-react';
import { ERowColor } from 'shared/ui/table';

export const useRowColorSelector = () => {
  return (item: Broadcast) => {
    if (!item.mappings) return ERowColor.GRAY;
    if (!item.mappings.length) return ERowColor.RED;

    for (const { mappingType } of item.mappings) {
      if (mappingType === MappingType.OPERATOR) return ERowColor.BLUE;
      if (mappingType === MappingType.AUTOBETRADARID || mappingType === MappingType.AUTOSYNONYMS) return ERowColor.GREEN;
      if (mappingType === MappingType.NOTMAPPED) return ERowColor.RED;
    }

    return ERowColor.GRAY;
  };
};
